<script>
</script>

<div class="scroll-down-button" on:click|capture|stopPropagation|preventDefault>
	<svg viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.4" d="M1 1L8.5 8L16 1" stroke="white" stroke-width="2" />
	</svg>

	<div>zum Artikel</div>
</div>

<style lang="scss">
	.scroll-down-button {
		position: absolute;
		transform: translate(-50%, 0);
		left: 50%;
		bottom: 8px;
		width: fit-content;
		display: flex;
		align-items: center;
		padding: 10px 23px;
		gap: 8px;
		cursor: pointer;
		font-weight: $medium;
		color: $white;
		background: rgba($main-blue, 0.8);
		box-shadow: 0px 0px 5px rgba(255, 255, 255, 0.18);
		backdrop-filter: blur(10px);
		-webkit-backdrop-filter: blur(10px);
		border-radius: 71px;
		font-size: 14px;
		line-height: 120%; /* 16.8px */
		letter-spacing: 0.14px;
		z-index: 2;

		// @media (max-width: $breakpoint-mobile-l) {
		// 	background: rgba($main-blue, 0.95);
		// }

		svg {
			width: 12px;
			height: 12px;
		}
	}
</style>
